module.exports = "<svg class=h-fill-gmw-icon> <use xlink:href=\"\" ng-attr-xlink:href=\"{{'#' + icon + '-icon'}}\"></use> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/directives/svg-icon/svg-icon.html
// module id = 1051
// module chunks = 0